import { render } from "./ConfiguratorPage.vue?vue&type=template&id=22021954"
import script from "./ConfiguratorPage.vue?vue&type=script&lang=js"
export * from "./ConfiguratorPage.vue?vue&type=script&lang=js"

import "./ConfiguratorPage.vue?vue&type=style&index=0&id=22021954&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__